import React, { useContext, useEffect, useState } from "react";
import { Button, Modal, List, Select } from "antd";
import logoImg from "../../assets/images/MizuWatch.png";
import logoImgs from "../../assets/images/MizuSmart_.png";
import avtar from "../../assets/images/team-2.jpg";
import profilePic from "../../assets/images/profile.svg";
import UserPic from "../../assets/images/user.svg";
import notificationBing from "../../assets/images/notification-bing.svg";
import logout from "../../assets/images/logout.svg";

import Dropdown from "react-bootstrap/Dropdown";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";

import { remove } from "../../Libraries/Ajax/HttpService";
import { DistrictContext } from "../../utils/DistrictContext";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const { Option } = Select;

const Header = () => {
  const navigate = useNavigate();
  const { setSelectedDistrict } = useContext(DistrictContext);

  // ------------------------ STATES ------------------------
  const [user, setUser] = useState("");
  const [district, setDistrict] = useState([]);
  const [selectedDistrictState, setSelectedDistrictState] = useState("");
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [openNotificationModal, setOpenNotificationModal] = useState(false);

  // ------------------------ LOAD USER DATA ------------------------
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("MCData"));

    setUser(data?.name || "");
    setDistrict(data?.district || []);

    setSelectedDistrictState(
      data?.selectedDistrict ||
        (data?.district?.length > 0 ? data.district[0].district_name : "")
    );
  }, []);

  // ------------------------ DISTRICT CHANGE ------------------------
  const handleDistrictChange = (value) => {
    setSelectedDistrictState(value);

    const stored = JSON.parse(localStorage.getItem("MCData")) || {};
    stored.selectedDistrict = value;
    localStorage.setItem("MCData", JSON.stringify(stored));

    setSelectedDistrict(value);
  };

  // ------------------------ LOGOUT CONFIRM ------------------------
  const logoutConfirm = () => {
    remove("apis/user_logout")
      .then(() => {
        localStorage.clear();
        toast.success("Logged out successfully", { autoClose: 800 });
        navigate("/login");
      })
      .catch(() => {
        toast.error("Error during logout.");
      });

    setShowLogoutModal(false);
  };

  return (
    <div className="header">
      {/* Logo */}
      <div className="McCORD_logo">
        {window.location.href.indexOf("mizuwatch.com") > -1 ? (
          <img src={logoImg} className="img-fluid" alt="Logo" />
        ) : (
          <img src={logoImgs} className="img-fluid" alt="Logo" />
        )}
      </div>

      {/* District Dropdown */}
      {district?.length > 0 && (
        <div id="1st" className="col ps-0 set-date-year">
          <div
            className="d-flex gap-1 w-10 selectCalenders calender-new me-4"
            style={{ borderRadius: "0", boxShadow: "none", padding: "0" }}
          >
            <Select
              value={selectedDistrictState || undefined}
              style={{ minWidth: "145px", padding: "6px 0px" }}
              bordered={false}
              disabled={district.length === 1}
              onChange={handleDistrictChange}
              placeholder="Select District"
            >
              {district.map((dist) => (
                <Option key={dist.id} value={dist.district_name}>
                  {dist.district_display_name}
                </Option>
              ))}
            </Select>
          </div>
        </div>
      )}

      {/* Right Section */}
      <div className="d-flex gap-2 align-items-center">
        <div>Welcome {user}</div>

        {/* Profile Dropdown */}
        <Dropdown className="logsettings">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            <img src={profilePic} alt="profile" style={{ width: "35px" }} />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={() => navigate("/profile")}>
              <img
                src={UserPic}
                alt="profile"
                style={{ width: "25px", marginRight: "15px" }}
              />
              Profile
            </Dropdown.Item>

            <Dropdown.Item onClick={() => navigate("/alert")}>
              <img
                src={notificationBing}
                alt="notification"
                style={{ width: "25px", marginRight: "15px" }}
              />
              Notification
            </Dropdown.Item>

            <Dropdown.Item onClick={() => setShowLogoutModal(true)}>
              <img
                src={logout}
                alt="logout"
                style={{ width: "25px", marginRight: "15px" }}
              />
              Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        {/* Logout Modal */}
        <Modal
          open={showLogoutModal}
          title="Logout"
          onCancel={() => setShowLogoutModal(false)}
          footer={[
            <Button key="cancel" onClick={() => setShowLogoutModal(false)}>
              Cancel
            </Button>,
            <Button key="confirm" type="primary" onClick={logoutConfirm}>
              Yes, I'm sure
            </Button>,
          ]}
        >
          <p className="text-center">Are you sure you want to logout?</p>
        </Modal>

        {/* Notification Modal */}
        <Modal
          open={openNotificationModal}
          onCancel={() => setOpenNotificationModal(false)}
          footer={null}
          centered
        >
          <form className="form-horizontal bg-white mx-auto p-3 login-form">
            <span className="text-red">101893: Signal strength is low</span>
            <br />
            <span className="text-red">95434: Battery level is low</span>
          </form>
        </Modal>
      </div>
    </div>
  );
};

export default Header;
